import { URL_IMAGES } from 'utils/constants'

export const HELPER_LINKS_URIS = {
  devCenter: 'https://developers.conekta.com/',
  goToHome: '/',
  helpCenter: 'https://help.conekta.com/hc/'
}

export const MAIN_ILLUSTRATION = `${URL_IMAGES}Ilustraciones/error-page.svg`

export const TRANSLATIONS_TYPE: Record<string, string> = { '*': 'common', '/oops': 'oops', '/onboarding': 'common' }
